// extracted by mini-css-extract-plugin
var _1 = "AttachmentItem-module__animatedBackground--zHmqb";
var _2 = "AttachmentItem-module__attachment--ioNTD";
var _3 = "AttachmentItem-module__container--stJtb";
var _4 = "AttachmentItem-module__doc--KjQeu";
var _5 = "AttachmentItem-module__docx--zAETn";
var _6 = "AttachmentItem-module__gif--k6Acy";
var _7 = "AttachmentItem-module__icon--ekfx6";
var _8 = "AttachmentItem-module__jpeg--OrDnG";
var _9 = "AttachmentItem-module__jpg--E4ZGS";
var _a = "AttachmentItem-module__link--hwZE5";
var _b = "AttachmentItem-module__menu--Z1Kn6";
var _c = "AttachmentItem-module__menuButton--Ku8S7";
var _d = "AttachmentItem-module__menuOpen--GVFFl";
var _e = "AttachmentItem-module__name--_wXZF";
var _f = "AttachmentItem-module__pdf--dMrgA";
var _10 = "AttachmentItem-module__png--SKWak";
var _11 = "AttachmentItem-module__ppt--JKac7";
var _12 = "AttachmentItem-module__pptx--lmH_q";
var _13 = "AttachmentItem-module__progressActive--X3tkK";
var _14 = "AttachmentItem-module__size--ZbRJ2";
var _15 = "AttachmentItem-module__sketch--qgtkf";
var _16 = "AttachmentItem-module__source--VxQBK";
var _17 = "AttachmentItem-module__svg--zTTTW";
var _18 = "AttachmentItem-module__type--djDYx";
var _19 = "AttachmentItem-module__uploading--yE2Si";
var _1a = "AttachmentItem-module__xls--_e6TX";
var _1b = "AttachmentItem-module__xlsx--OD0pm";
export { _1 as "animatedBackground", _2 as "attachment", _3 as "container", _4 as "doc", _5 as "docx", _6 as "gif", _7 as "icon", _8 as "jpeg", _9 as "jpg", _a as "link", _b as "menu", _c as "menuButton", _d as "menuOpen", _e as "name", _f as "pdf", _10 as "png", _11 as "ppt", _12 as "pptx", _13 as "progressActive", _14 as "size", _15 as "sketch", _16 as "source", _17 as "svg", _18 as "type", _19 as "uploading", _1a as "xls", _1b as "xlsx" }
